// Dodržiavanie limitov a technických podmienok for operational log entries (prevádzkový denník)
// Keep in sync with server/config/limitsCompliance.js
export const LIMITS_COMPLIANCE = {
    COMPLIANT: 'COMPLIANT',
    EXCEEDED: 'EXCEEDED',
};

export const LIMITS_COMPLIANCE_LABELS = {
    COMPLIANT: 'Dodržané',
    EXCEEDED: 'Zistené prekročenie',
};

export const LIMITS_COMPLIANCE_OPTIONS = Object.entries(LIMITS_COMPLIANCE_LABELS).map(([value, label]) => ({ value, label }));
